import React, { useState } from "react";
import { LinkContainer, IfPermitted, ShareButton } from "components/common";
import { ButtonToolbar, Button } from "components/bootstrap";
import EntityShareModal from "components/permissions/EntityShareModal";
import SecurityRoutes from "security/Routes";
const TeamActionLinks = ({ team }) => {
  const [showShareModal, setShowShareModal] = useState(false);
  if (!team) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `team:read:${team.id}` }, /* @__PURE__ */ React.createElement(LinkContainer, { to: SecurityRoutes.TEAMS.DETAILS(team.id) }, /* @__PURE__ */ React.createElement(Button, null, "View Details"))), /* @__PURE__ */ React.createElement(
    IfPermitted,
    {
      permissions: [`team:edit:${team.id}`, `team_users:edit:${team.id}`, `team:rolesedit:${team.id}`],
      anyPermissions: true
    },
    /* @__PURE__ */ React.createElement(LinkContainer, { to: SecurityRoutes.TEAMS.EDIT(team.id) }, /* @__PURE__ */ React.createElement(Button, null, "Edit Team"))
  ), /* @__PURE__ */ React.createElement(ShareButton, { title: "Manage", entityId: team.id, entityType: "team", onClick: () => setShowShareModal(true) })), showShareModal && /* @__PURE__ */ React.createElement(
    EntityShareModal,
    {
      entityId: team.id,
      entityType: "team",
      entityTitle: team.name,
      description: "Search for a User or Team to add as collaborator on this Team.",
      onClose: () => setShowShareModal(false)
    }
  ));
};
export default TeamActionLinks;
